import { canUseDOM, get } from '../../utils';
export const ANNUAL_FEE = 'universityPrograms.programs.annualFeeRange';
export const splitter = ';,;';
export const addQueryString = (facetsName, value, history) => {
  if (canUseDOM) {
    const url = new URL(window.location.href);
    url.searchParams.set(facetsName, `${value}`);
    history.replace(`${history.location.pathname}${url.search}${url.hash}`);
  }
};
export const deleteQueryString = (facetsName, history) => {
  if (canUseDOM) {
    const url = new URL(window.location.href);
    url.searchParams.delete(facetsName);

    // @ts-ignore
    if ([...url.searchParams.keys()].length) {
      history.push(`${url.search}${url.hash}`);
    } else {
      history.push(window.location.pathname);
    }
  }
};
export const addQueryStringMultiple = function (facetsName, values, history) {
  let withoutSavingPrevValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  if (canUseDOM) {
    const url = new URL(window.location.href);
    let current = url.searchParams.get(facetsName) || '';
    const newQueryArr = [];
    if (!withoutSavingPrevValues) {
      // save values from others filters
      current.split(splitter).forEach(v => {
        const val = v.trim();
        if (val && typeof values[val] === 'undefined') {
          newQueryArr.push(val);
        }
      });
    }
    if (values.length) {
      values.forEach(key => newQueryArr.push(key));
    } else {
      Object.keys(values).forEach(key => {
        if (values[key]) {
          newQueryArr.push(key);
        }
      });
    }
    url.searchParams.set(facetsName, newQueryArr.join(splitter));
    history.push(`${url.search}${url.hash}`);
  }
};
export const clearCurrentFacetFromQueryString = (facetsName, options, history) => {
  if (canUseDOM) {
    const url = new URL(window.location.href);
    let qsFacetValuesParam = url.searchParams.get(facetsName) || '';
    if (qsFacetValuesParam) {
      const qsFacetValues = qsFacetValuesParam.split(splitter);
      const setToRemove = new Set(options);
      const cleanFacets = qsFacetValues.filter(value => !setToRemove.has(value));
      if (cleanFacets.length) {
        url.searchParams.set(facetsName, cleanFacets.join(splitter));
      } else {
        url.searchParams.delete(facetsName);
      }
      history.push(`${url.pathname}${url.search}${url.hash}`);
    }
  }
};
export const removeQuerySortingString = function (facetsNames, history) {
  let searchIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  if (canUseDOM) {
    const url = new URL(window.location.href);
    facetsNames.forEach(facetsName => {
      url.searchParams.delete(`${searchIndex}_asc_${facetsName}`);
    });

    // @ts-ignore
    if ([...url.searchParams.keys()].length) {
      history.push(`${url.search}${url.hash}`);
    } else {
      history.push(window.location.pathname);
    }
  }
};
export const addQuerySorting = function (facetsNames, values, history) {
  let searchIndex = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  if (canUseDOM) {
    const url = new URL(window.location.href);
    facetsNames.forEach(facetsName => {
      url.searchParams.delete(`${searchIndex}_asc_${facetsName}`);
    });
    const entriesValues = Object.entries(values).filter(_ref => {
      let [key, v] = _ref;
      return v;
    });
    if (entriesValues.length) {
      entriesValues.forEach(_ref2 => {
        let [key] = _ref2;
        url.searchParams.set(`${searchIndex}_asc_${key}`, '');
      });
      history.push(`${url.search}${url.hash}`);
    }
  }
};
export const removeQueryString = (facetsName, history) => {
  if (canUseDOM) {
    const url = new URL(window.location.href);
    url.searchParams.delete(facetsName);
    history.push(`${url.pathname}${url.search}`);
  }
};
export const totalParams = () => {
  if (canUseDOM) {
    const url = new URL(window.location.href);
    return Array.from(url.searchParams).length;
  }
  return 0;
};
export const getAlgoliaTagsList = filters => {
  const output = [];
  if (filters && Array.isArray(filters.values)) {
    filters.values.filter(i => i.fieldNameItem).map(item => {
      return get(item, 'fieldNameItem.item.fieldName.value') || get(item, 'fieldNameItem.item.dateFromFieldName.value');
    }).forEach(value => {
      if (value) {
        output.push(value);
      }
    });
    filters.values.filter(i => i.fieldNameItems).forEach(item => {
      if (get(item, 'fieldNameItems.items.0.fieldName.value', '') === 'venue.rooms.typeRoom') {
        output.push(get(item, 'fieldNameItems.items.0.fieldName.value', ''));
      } else {
        get(item, 'fieldNameItems.items', []).forEach(item => {
          if (get(item, 'fieldName.value', '')) {
            output.push(get(item, 'fieldName.value', ''));
          }
        });
      }
    });
  }
  return output;
};
export const convertQueryParamsToFacets = function (queryString) {
  let returnType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  let filters = arguments.length > 2 ? arguments[2] : undefined;
  let facets = [];
  let tags = getAlgoliaTagsList(filters);
  Object.keys(queryString).map(item => {
    if (tags.indexOf(item) > -1 || item.indexOf('curators') > -1) {
      if (item !== 'eventDatesRange' && item !== ANNUAL_FEE && item !== 'valid' && item !== "totalHotelRooms") {
        const queryValue = queryString[item];
        item = item === 'maxDelegates' ? 'maxDelegatesRangeIndex' : item;
        facets.push(queryValue.split(splitter).map(query => {
          if (!parseInt(query)) {
            if (returnType) return `${item}:${query.split('+').join(' ')}`;else return `${query.split('+').join(' ')}`;
          } else {
            if (query.indexOf('+') > -1) {
              query = query.split('+').join(' ');
            }
            if (returnType) return `${item}:${query}`;else return `${query}`;
          }
        }));
      }
    }
  });
  return facets;
};
export const convertQueryParamsToFacetsWithoutPlusReplacement = function (queryString) {
  let returnType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  let filters = arguments.length > 2 ? arguments[2] : undefined;
  let facets = [];
  let tags = getAlgoliaTagsList(filters);
  Object.keys(queryString).map(item => {
    if (tags.indexOf(item) > -1 || item.indexOf('curators') > -1) {
      if (item !== 'eventDatesRange' && item !== ANNUAL_FEE && item !== 'valid' && item !== "totalHotelRooms") {
        const queryValue = queryString[item];
        item = item === 'maxDelegates' ? 'maxDelegatesRangeIndex' : item;
        facets.push(queryValue.split(splitter).map(query => {
          if (returnType) return `${item}:${query}`;else return `${query}`;
        }));
      }
    }
  });
  return facets;
};
export const generateFacetForRequest = function (selectedFilters, filters) {
  let excludeTags = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  let facets = [];
  let tags = getAlgoliaTagsList(filters);
  Object.keys(selectedFilters).forEach(item => {
    if (tags.includes(item)) {
      if (item !== 'eventDatesRange' && item !== ANNUAL_FEE && item !== 'valid' && item !== "totalHotelRooms" && !excludeTags.includes(item)) {
        if (selectedFilters[item].length) {
          facets.push(selectedFilters[item].map(value => `${item}:${value}`));
        }
      }
    }
  });
  return facets;
};
export default addQueryString;